import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Config } from 'app/_helper/config';
import { BaseService } from 'app/service/base.service';

    
    @Injectable({
      providedIn: 'root'
    })
    export class PusherService extends BaseService {

      pusher: any
        
      private _OnPrioridadeChanged : Subject<any>;
      private _OnExameAndamentoChanged : Subject<any>;

      constructor() { 
        super(null, '');
        this.pusher = new Pusher(Config.info.pusher.PUSHER_API_KEY, {
          cluster: Config.info.pusher.PUSHER_API_CLUSTER,
          forceTLS: true
        });
        this.onEstabelecimentoChanged
        .subscribe(()=> {
          this._OnExameAndamentoChanged = null;
          this._OnPrioridadeChanged = null;
        });
      }

      public OnPrioridadeChanged()
      {
        if(this._OnPrioridadeChanged == null && super.getUser() != null)
        {
            this._OnPrioridadeChanged = new Subject();
            this.subScribeToChannel("PRIORIDADE", [super.getUser().id_estabelecimento], (evt)=>this._OnPrioridadeChanged.next(evt));
        }
        return this._OnPrioridadeChanged;
      }

      public OnExameAndamentoChanged()
      {
        if(this._OnExameAndamentoChanged == null && super.getUser() != null)
        {
            this._OnExameAndamentoChanged = new Subject();
            this.subScribeToChannel("EXAMEANDAMENTO", [super.getUser().id_estabelecimento], (evt)=>this._OnExameAndamentoChanged.next(evt));
        }
        return this._OnExameAndamentoChanged;
      }

      private subScribeToChannel(channelName: String, events: String[], cb: Function) {
        var channel = this.pusher.subscribe(channelName);

        events.forEach( event => {
          channel.bind(event, (data) => cb(data));
        })
      }
      
    }